import { render, staticRenderFns } from "./PForm.vue?vue&type=template&id=6ecb8bc4&scoped=true&"
import script from "./PForm.vue?vue&type=script&lang=ts&"
export * from "./PForm.vue?vue&type=script&lang=ts&"
import style0 from "./PForm.vue?vue&type=style&index=0&id=6ecb8bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecb8bc4",
  null
  
)

export default component.exports